import React from "react";

function Alert(props) {

  return (
    <>
      <div className="apply_form">
        <div className="scroll_wrap">
          <div className="form_wrap">
            <h1>
              <img src="../img/icon_notice_n.png" alt="icon" className="pop_none"/>
            </h1>
            <div className="con_tt">
                <p className="tt">잘못된 비밀번호 입니다.<br/>확인 후 다시 입력해주세요. </p>
                  <div className="btn_area col_2">
                    <span className="btn_mem blue">확인</span>
                  </div>
                </div>
            </div>
          </div>
      </div>
    </>
  );
}

export default Alert;
